import React from "react";
import routes from "../../../routes";
import { getAtributo } from "../context/FuncionesContext";
import {Redirect} from "react-router-dom";

const RedirectP = ({ configuracion, data }) => {
  try{

  const { enlace, enlace_externo, enlace_id_a } = configuracion.opciones;

  if (enlace_externo === "s") {
    return window.location.replace(enlace);
  }
  
  if(enlace_id_a){
    const ida = getAtributo("enlace_id_a", data, configuracion.opciones);
    return <Redirect to={`/pantalla/${ida}`} />;
  }

  const C = routes.find((r) => r.path === enlace).component;
  return <C />;
  
  }catch(e){
    return <></>
  }
};

export default RedirectP;
